export function objectToQueryString(obj: { [key: string]: any }): string {
    if (Object.keys(obj).length === 0){
        return ''
    }
    const queryString = Object.keys(obj)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
        .join('&');
    return queryString;
}